import { protectedRoute } from "@/utils/routeUtils";

const allowedRoles = ["DIVISION_ER_USER", "isHRApprover"];

const billingApprovalRoutes = {
  path: "billing-approval",
  title: "module_title.billing_approval",
  sidebarProps: {
    key: "1-17",
    iconSrc: "billing-approval",
    label: "module_title.billing_approval",
    link: "/billing-approval",
    groupingType: "TOOLS",
    order: 17,
    permissions: allowedRoles,
  },
  element: protectedRoute(
    [() => import("@/pages/billing-approval/BillingApproval")],
    allowedRoles
  ),
};

export default billingApprovalRoutes;
